var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrxIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#EF0027"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3367 5.57603L4.21875 4.08203L8.49094 14.8325L14.4439 7.57966L12.3367 5.57603ZM12.2063 6.23416L13.4483 7.41484L10.0519 8.02966L12.2063 6.23416ZM9.31388 7.90647L5.73413 4.93759L11.5853 6.01422L9.31388 7.90647ZM9.05906 8.43184L8.47519 13.2581L5.328 5.33641L9.05906 8.43184ZM9.59906 8.68778L13.3605 8.00716L9.04613 13.2626L9.59906 8.68778Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrxIcon);
export default __webpack_public_path__ + "static/media/trxIcon.839e33f76bb2ac4340efe7e6732cf2b1.svg";
export { ForwardRef as ReactComponent };